import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/open-btn.png'
import _imports_1 from '@/assets/img/open-return.png'


const _hoisted_1 = { class: "open-wrapper" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "bottom" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (!_ctx.showResult)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              class: "btn open-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openClick && _ctx.openClick(...args))),
              src: _imports_0
            }))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              class: "btn return-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.returnClick && _ctx.returnClick(...args))),
              src: _imports_1
            }))
      ]),
      _createVNode("div", {
        class: ["inner", _ctx.showResult && 'open']
      }, "￥1.88元", 2),
      _hoisted_4
    ])
  ]))
}